<template>
  <div v-if="withProgressInfo" class="progress-info">
    <div class="progress-percentage">
      <span class="text-sm font-weight-bold">{{ percentage }}</span>
    </div>
  </div>
  <div class="progress">
    <div
      class="progress-bar"
      :class="getClasses(color, variant)"
      :style="{ width: percentage }"
    ></div>
  </div>
</template>

<script>
export default {
  name: "ArgonProgress",
  props: {
    color: {
      type: String,
      default: "success",
    },
    variant: {
      type: String,
      default: "fill",
    },
    percentage: {
      type: Number,
      required: true,
    },
    withProgressInfo: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getClasses: (color, variant) => {
      let colorValue;

      if (variant === "gradient") {
        colorValue = `bg-gradient-${color}`;
      } else {
        colorValue = `bg-${color}`;
      }

      return `${colorValue}`;
    },
  },
};
</script>
